const ElementPanic = "ElementPanic";
function ElementPanicMixin(Base) {
  return class extends Base {
    panic(error) {
      this.dispatchEvent(
        new CustomEvent(ElementPanic, {
          bubbles: true,
          cancelable: true,
          detail: error
        })
      );
    }
  };
}
export {
  ElementPanic,
  ElementPanicMixin
};
